import { useTranslation } from 'next-i18next'

import { memo } from 'react'

import { Topic } from '~/types/theory'
import { isFile } from '~/../utils/data-fetch/theory/theory.query'

import Metatags from './Metatags'
import { localePathsFromSiblings } from './hreflang.util'

const TopicMetatags = ({ topic }: { topic: Topic }): React.ReactElement => {
  const { metaDescription, title, h1, otherLocales, image, type, localeSiblings } = topic
  const { t } = useTranslation(type)
  const topicIsFile = isFile(topic)
  const metaImage = topicIsFile || !image ? image : { ...image, alt: t('encyclopedia:previewAltOGP', { h1 }) }
  const contentType = topicIsFile ? 'article' : 'website'
  return (
    <Metatags
      contentType={contentType}
      h1={h1}
      image={topicIsFile ? metaImage : undefined}
      localePaths={localePathsFromSiblings('', localeSiblings ?? [])}
      metaDescription={metaDescription}
      otherLocales={otherLocales}
      title={title}
    />
  )
}

export default memo(TopicMetatags)
